export const TypeImport = {
    YNT: 'ynt-import',
    YNT_MR: 'ynt-monitoring-report-import'
};